export const MuiTextField = {
  styleOverrides: {
    root: {
      marginTop: '10px',
      width: '100%',
    },
  },
};
